<template>
    <textarea v-if="classify == 'textarea'"
        :value="currentValue"
        @focus="onFocus"
        @blur="onBlur"
        @input="onInput"
        @change="onChange"
        @keydown="onKeydown">
    </textarea>
    <input v-else
        :value="currentValue"
        @focus="onFocus"
        @blur="onBlur"
        @input="onInput"
        @change="onChange"
        @keydown="onKeydown">
</template>
<script>
/* eslint-disable */
import textCheck from "assets/js/textCheck";
import textCheck_demo from "assets/js/textCheck_demo";
import textCheck_suisei from "assets/js/textCheck_suisei";
import textCheck_diesel from "assets/js/textCheck_diesel";
import textCheck_albion from "assets/js/textCheck_albion";
import EventBus from 'assets/js/eventBus';
import common from 'assets/js/common';

export default {
    name: 'InputCheck',
    props: {
        value: {
            type: [String, Number],
            default: null
        },
        classify: {
            type: String,
            default: 'input'
        }
    },
    data () {
        return {
            currentValue: this.value,
            regCh: /[\W\w]/,
            regAll: /[\W\w]/
        };
    },
    methods: {
        onFocus (event) {
            if (this.$el.classList.contains('tel') || this.$el.classList.contains('zip1') || this.$el.classList.contains('zip2') ||
                this.$el.classList.contains('zip') || this.$el.classList.contains('int') || this.$el.classList.contains('num') ||
                this.$el.classList.contains('numcode') || this.$el.classList.contains('ymd') || this.$el.classList.contains('ym') ||
                this.$el.classList.contains('time') || this.$el.classList.contains('float') || this.$el.classList.contains('code') ||
                this.$el.classList.contains('code2') || this.$el.classList.contains('code3') || this.$el.classList.contains('half') ||
                this.$el.classList.contains('en') || this.$el.classList.contains('mail') || this.$el.classList.contains('mail2') ||
                this.$el.classList.contains('color')){
                    var isMoible = common.isMobile();
                    if(event.target.type != "password" && !isMoible) {
                        event.target.type = "tel";
                    }
            }
            this.$emit('on-focus', event);
        },
        onKeydown (event) {
            this.$emit('on-key-down', event);
        },
        onBlur (event) {
            if (this.$el.classList.contains('tel') || this.$el.classList.contains('zip1') || this.$el.classList.contains('zip2') ||
                this.$el.classList.contains('zip') || this.$el.classList.contains('int') || this.$el.classList.contains('num') ||
                this.$el.classList.contains('numcode') || this.$el.classList.contains('ymd') || this.$el.classList.contains('ym') ||
                this.$el.classList.contains('time') || this.$el.classList.contains('float') || this.$el.classList.contains('code') ||
                this.$el.classList.contains('code2') || this.$el.classList.contains('code3') || this.$el.classList.contains('half') ||
                this.$el.classList.contains('en') || this.$el.classList.contains('mail') || this.$el.classList.contains('mail2') ||
                this.$el.classList.contains('color')){
                    if(event.target.type != "password") {
                        event.target.type = "text";
                    }
            }
            let actual_len = event.target.value.length;
            let str_len = this.countLength(event.target.value);
            if (str_len != actual_len) {
                try {
                    if(this.$el.classList.contains('float')){
                        this.regCh = /^[0-9.]*$/; this.regAll = /^[0-9.]*$/;
                    } else if(this.$el.classList.contains('code')){
                        this.regCh = /^[0-9a-zA-Z-_*]*$/; this.regAll = /^[0-9a-zA-Z-_*]*$/;
                    } else if(this.$el.classList.contains('code2')){
                        this.regCh = /[0-9a-zA-Z-_\/*]/; this.regAll = /^[0-9a-zA-Z-_\/*]*$/;
                    } else if(this.$el.classList.contains('code3')){
                        this.regCh = /^[0-9a-zA-Z- _\/*]*$/; this.regAll = /^[0-9a-zA-Z- _\/*]*$/;
                    } else if(this.$el.classList.contains('half')){
                        this.regCh = /^[0-9a-zA-Z~`!@#$%^&*\(\)_\-+={}\[\]\|\\;:"',<>.?\/]*$/;
                        this.regAll = /^[0-9a-zA-Z~`!@#$%^&*\(\)_\-+={}\[\]\|\\;:"',<>.?\/]*$/;
                    } else if(this.$el.classList.contains('numcode')){
                        this.regCh = /^[0-9]*$/; this.regAll = /^[0-9]*$/; 
                    } else if(this.$el.classList.contains('int')){
                        this.regCh = /^[0-9-]*$/; this.regAll = /^[0-9-]*$/; 
                    } else if(this.$el.classList.contains('tel')){
                        this.regCh = /^[0-9-]*$/; this.regAll = /^[0-9-]*$/; 
                    } else if(this.$el.classList.contains('zip')){
                        this.regCh = /^[0-9-]*$/; this.regAll = /^[0-9-]*$/; 
                    } else if(this.$el.classList.contains('zip1')){
                        this.regCh = /^[0-9]*$/; this.regAll = /^[0-9]*$/; 
                    } else if(this.$el.classList.contains('zip2')){
                        this.regCh = /^[0-9]*$/; this.regAll = /^[0-9]*$/; 
                    } else if(this.$el.classList.contains('num')){
                        this.regCh = /^[0-9]*$/; this.regAll = /^[0-9]*$/; 
                    } else if(this.$el.classList.contains('en')){
                        this.regCh = /^[\x00-\xff]*$/; this.regAll = /^[\x00-\xff]*$/; 
                    } else if(this.$el.classList.contains('ymd')){
                        this.regCh = /^[0-9/]*$/; this.regAll = /^[0-9/]*$/;
                    } else if(this.$el.classList.contains('ym')){
                        this.regCh = /^[0-9/]*$/; this.regAll = /^[0-9/]*$/;
                    } else if(this.$el.classList.contains('time')){
                        this.regCh = /^[0-9/]*$/; this.regAll = /^[0-9/]*$/;
                    } else if(this.$el.classList.contains('mail')){
                        this.regCh = /^[0-9a-zA-Z-_@.*!#$%&'+/=?^`{|}~;]*$/; this.regAll = /^[0-9a-zA-Z-_@.*!#$%&'+/=?^`{|}~;]*$/;
                    } else if(this.$el.classList.contains('mail2')){
                        this.regCh = /^[0-9a-zA-Z-_@.*!#$%&'+/=?^`{|}~;]*$/; this.regAll = /^[0-9a-zA-Z-_@.*!#$%&'+/=?^`{|}~;]*$/;
                    } else if(this.$el.classList.contains('color')){
                        this.regCh = /^[0-9a-fA-F#]*$/; this.regAll = /^[0-9a-fA-F#]*$/; 
                    }

                    var pos = event.target.selectionStart;
                    var data = event.data;
                    if(!this.regAll.test(event.target.value)) {
                        var letter = event.target.value.split("");
                        event.target.value = "";
                        for (var i = 0; i < letter.length; i++) {
                            if(letter[i].charCodeAt(0) == 10 || letter[i].charCodeAt(0) == 32) {
                                if(this.classify == 'textarea') {
                                    event.target.value += letter[i];  
                                }
                            } else if(this.regAll.test(letter[i])) {
                                event.target.value += letter[i];
                            }
                        }
                        if (!this.regAll.test(data)) {
                            if(this.classify == 'textarea') {
                                if(data.charCodeAt(0) != 10 && data.charCodeAt(0) != 32) {
                                    pos = pos - data.length;
                                }
                            } else {
                                pos = pos - data.length;
                            }
                        }
                        event.target.selectionStart = pos;
                        event.target.selectionEnd = pos;
                    }
                } catch(e){}
                this.$emit('input', event.target.value);
            }
            this.$emit('on-blur', event);
        },
        onInput (event) {
            let actual_len = event.target.value.length;
            let str_len = this.countLength(event.target.value);
            if (str_len == actual_len) {
                try {
                    if(this.$el.classList.contains('float')){
                        this.regCh = /^[0-9.]*$/; this.regAll = /^[0-9.]*$/;
                    } else if(this.$el.classList.contains('code')){
                        this.regCh = /^[0-9a-zA-Z-_*]*$/; this.regAll = /^[0-9a-zA-Z-_*]*$/;
                    } else if(this.$el.classList.contains('code2')){
                        this.regCh = /[0-9a-zA-Z-_\/*]/; this.regAll = /^[0-9a-zA-Z-_\/*]*$/;
                    } else if(this.$el.classList.contains('code3')){
                        this.regCh = /^[0-9a-zA-Z- _\/*]*$/; this.regAll = /^[0-9a-zA-Z- _\/*]*$/;
                    } else if(this.$el.classList.contains('half')){
                        this.regCh = /^[0-9a-zA-Z~`!@#$%^&*\(\)_\-+={}\[\]\|\\;:"',<>.?\/]*$/;
                        this.regAll = /^[0-9a-zA-Z~`!@#$%^&*\(\)_\-+={}\[\]\|\\;:"',<>.?\/]*$/;
                    } else if(this.$el.classList.contains('numcode')){
                        this.regCh = /^[0-9]*$/; this.regAll = /^[0-9]*$/; 
                    } else if(this.$el.classList.contains('int')){
                        this.regCh = /^[0-9-]*$/; this.regAll = /^[0-9-]*$/; 
                    } else if(this.$el.classList.contains('tel')){
                        this.regCh = /^[0-9-]*$/; this.regAll = /^[0-9-]*$/; 
                    } else if(this.$el.classList.contains('zip')){
                        this.regCh = /^[0-9-]*$/; this.regAll = /^[0-9-]*$/; 
                    } else if(this.$el.classList.contains('zip1')){
                        this.regCh = /^[0-9]*$/; this.regAll = /^[0-9]*$/; 
                    } else if(this.$el.classList.contains('zip2')){
                        this.regCh = /^[0-9]*$/; this.regAll = /^[0-9]*$/; 
                    } else if(this.$el.classList.contains('num')){
                        this.regCh = /^[0-9]*$/; this.regAll = /^[0-9]*$/; 
                    } else if(this.$el.classList.contains('en')){
                        this.regCh = /^[\x00-\xff]*$/; this.regAll = /^[\x00-\xff]*$/; 
                    } else if(this.$el.classList.contains('ymd')){
                        this.regCh = /^[0-9/]*$/; this.regAll = /^[0-9/]*$/;
                    } else if(this.$el.classList.contains('ym')){
                        this.regCh = /^[0-9/]*$/; this.regAll = /^[0-9/]*$/;
                    } else if(this.$el.classList.contains('time')){
                        this.regCh = /^[0-9/]*$/; this.regAll = /^[0-9/]*$/;
                    } else if(this.$el.classList.contains('mail')){
                        this.regCh = /^[0-9a-zA-Z-_@.*!#$%&'+/=?^`{|}~;]*$/; this.regAll = /^[0-9a-zA-Z-_@.*!#$%&'+/=?^`{|}~;]*$/;
                    } else if(this.$el.classList.contains('mail2')){
                        this.regCh = /^[0-9a-zA-Z-_@.*!#$%&'+/=?^`{|}~;]*$/; this.regAll = /^[0-9a-zA-Z-_@.*!#$%&'+/=?^`{|}~;]*$/;
                    } else if(this.$el.classList.contains('color')){
                        this.regCh = /^[0-9a-fA-F#]*$/; this.regAll = /^[0-9a-fA-F#]*$/; 
                    }

                    var pos = event.target.selectionStart;
                    var data = event.data;
                    if(!this.regAll.test(event.target.value)) {
                        var letter = event.target.value.split("");
                        event.target.value = "";
                        for (var i = 0; i < letter.length; i++) {
                            if(letter[i].charCodeAt(0) == 10 || letter[i].charCodeAt(0) == 32) {
                                if(this.classify == 'textarea') {
                                    event.target.value += letter[i];  
                                }
                            } else if(this.regAll.test(letter[i])) {
                                event.target.value += letter[i];
                            }
                        }
                        if (!this.regAll.test(data)) {
                            if(this.classify == 'textarea') {
                                if(data.charCodeAt(0) != 10 && data.charCodeAt(0) != 32) {
                                    pos = pos - data.length;
                                }
                            } else {
                                pos = pos - data.length;
                            }
                        }
                        event.target.selectionStart = pos;
                        event.target.selectionEnd = pos;
                    }
                } catch(e){}
            }
            
            let value = event.target.value;
            this.$emit('input', value);
            this.setCurrentValue(value);
            this.$emit('on-change', event);
            this.forbiddenCharacterCheck();
            event.target.value = this.currentValue;
            this.$emit('input', this.currentValue);
        },
        countLength(str) {
            let r = 0;
            for (let i = 0; i < str.length; i++) {
                const c = str.charCodeAt(i);
                // Shift_JIS: 0x0 ～ 0x80, 0xa0 , 0xa1 ～ 0xdf , 0xfd ～ 0xff
                // Unicode : 0x0 ～ 0x80, 0xf8f0, 0xff61 ～ 0xff9f, 0xf8f1 ～ 0xf8f3
                if ( (c >= 0x0 && c < 0x81) || (c === 0xf8f0) || (c >= 0xff61 && c < 0xffa0) || (c >= 0xf8f1 && c < 0xf8f4)) {
                    r += 1;
                } else {
                    r += 2;
                }
            }
            return r;
        },
        /*
        * 入力変更時の処理
        */
        onChange(event) {
            this.$emit('on-input-change', event);
        },
        setCurrentValue (value) {
            if (value === this.currentValue) return;
            this.currentValue = value;
            let afterReplaced = "";
            // E28091
            let strE28091 = "‑";
            let strE28091To = "－";
            afterReplaced = value.replace(new RegExp(strE28091, 'g'), strE28091To);
            // E28093
            let strE28093 = "–";
            afterReplaced = afterReplaced.replace(new RegExp(strE28093, 'g'), strE28091To);
            // E28094
            let strE28094 = "—";
            afterReplaced = afterReplaced.replace(new RegExp(strE28094, 'g'), strE28091To);
            // E28892
            let strE28892 = "−";
            afterReplaced = afterReplaced.replace(new RegExp(strE28892, 'g'), strE28091To);
            // E3809C
            let strE3809C = "〜";
            let strE3809CTo = "～";
            afterReplaced = afterReplaced.replace(new RegExp(strE3809C, 'g'), strE3809CTo);
            if (this.currentValue !== afterReplaced){
                this.currentValue = afterReplaced;
                this.$emit('input', this.currentValue);
            }
        },
        /*
        * 禁止文字チェック
        */
        forbiddenCharacterCheck() {
            // 入力値チェック
            var text = this.currentValue;
            var readOnly = this.$el.readOnly;
            if(text == ""){return true;}
            if(this.$el.classList.contains("num") || this.$el.classList.contains("float") 
                || this.$el.classList.contains("int") || this.$el.classList.contains("disp")) return true;
            if(readOnly == true){return true;}

            //「,」「'」と第三・第四水準漢字は禁止
            if (text == null) return true;
            var str = this.$i18n.t('String.Check.S1');
            var check = "";
            switch (str) {
                case "suisei" :
                    check = textCheck_suisei.match;
                    break;
                case "demo" :
                    check = textCheck_demo.match;
                    break;
                case "diesel" :
                    check = textCheck_diesel.match;
                    break;
                case "albion" :
                    check = textCheck_albion.match;
                    break;
                default :
                    check = textCheck.match;
                    break;
            }
            // グルメコンフォートの場合
            if (str == "gcomfort") {
                var textStr = text.split("");
                var replacedText = "";
                var cnt = 0;
                for (let i = 0; i< textStr.length; i++) {
                    if (!textStr[i].match(check)) {
                        textStr[i] = textStr[i].replaceAll( textStr[i], '■');
                        cnt++;
                    }
                    replacedText += textStr[i];
                }
                if (cnt > 0) {
                    this.currentValue = replacedText;
                    this.$emit('input', this.currentValue);
                    this.$emit('error-input', this.$el);
                    alert(this.$i18n.t('common.messages.kinshiMoji'));
                    return false;
                }

            // その他の場合
            } else {
                var textStr = text.split("");
                for (let i = 0; i< textStr.length; i++) {
                    if (!textStr[i].match(check)) {
                        alert(this.$i18n.t('common.messages.kinshiMoji'));
                        alert("使用できない文字"+ "「" + textStr[i] + "」" +"が入力されています。");
                        EventBus.$emit('error-input', this.$el);
                        return false;
                    }
                }
            }
            return true;
        }
    },
    watch: {
        value (val) {
            this.setCurrentValue(val);
        }
    }
};
</script>
